module.exports = __webpack_public_path__ + "fonts/montserrat-semibold.7c839d15.woff";